// src/pages/SettingsPage.js
import React, { useState } from "react";
import { API_URL } from "../config";

function SettingsPage({ currentUser }) {
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  return (
    <section className="settings-page">
      <h2>Ustawienia</h2>
      <button className="btn-submit change-password-btn" onClick={() => setShowChangePasswordModal(true)}>
        Zmień hasło
      </button>
      {showChangePasswordModal && (
        <ChangePasswordModal
          userId={currentUser.id}
          onClose={() => setShowChangePasswordModal(false)}
        />
      )}
    </section>
  );
}

function ChangePasswordModal({ userId, onClose }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Hasła nie są takie same");
      return;
    }
    if (!/^[a-zA-Z0-9!@#$%^&*]+$/.test(newPassword)) {
      setError("Niedozwolony znak");
      return;
    }
    try {
      const response = await fetch(`${API_URL}/changePassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, currentPassword, newPassword }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Błąd przy zmianie hasła");
      }
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Zmiana Hasła</h3>
        <p>Jeśli chcesz zmienić hasło, wypełnij poniższy formularz.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Podaj aktualne hasło"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Podaj nowe hasło"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Powtórz nowe hasło"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          {error && <p style={{ color: "red" }}>{error}</p>}
          <div className="modal-buttons">
            <button type="submit" className="btn-submit">
              Zapisz Nowe Hasło
            </button>
            <button type="button" className="btn-submit" onClick={onClose}>
              Anuluj
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SettingsPage;
